import {
  getDropperMaker,
  getSinkMaker,
  mkIQ as n,
  mkPercentageDrop as pd,
} from "./tools";

const order = getSinkMaker("post office");
export const postOfficeOrders = [
  order(
    "Simple Shippin'",
    n("Copper Ore", 150),
    n("Iron Ore", 150),
    n("Copper Bar", 50),
    n("Oak Logs", 200),
    n("Bleach Logs", 100),
    n("Jungle Logs", 80),
    n("Goldfish", 120),
    n("Fly", 120),
    n("Hermit Can", 100),
    n("Butterfly", 100),
    n("Iron Bar", 50),
    n("Thread", 100),
    n("Trusty Nails", 40),
    n("Gold Ore", 100),
    n("Gold Bar", 25),
    n("Potty Rolls", 125),
    n("Jellyfish", 70),
    n("Sentient Cereal", 90),
    n("Boring Brick", 25),
    n("Tropilogs", 110),
    n("Bloach", 40),
    n("Veiny Logs", 100),
    n("Fruitfly", 65),
  ),

  order(
    "Plan-it Express",
    n("Farmer Brim"),
    n("Wooden Spear"),
    n("Flip Flops"),
    n("Copper Boots"),
    n("Iron Boots"),
    n("Leather Cap"),
    n("Copper Platebody"),
    n("Top Hat"),
    n("Blue Tee"),
    n("Birch Longbow"),
    n("Iron Pickaxe"),
    n("Iron Helmet"),
    n("Gold Helmet"),
    n("Bandage Wraps"),
    n("Starlight"),
    n("Royal Bayonet"),
    n("Iron Hatchet"),
    n("Green Tee"),
    n("Gold Boots"),
    n("Copper Band"),
    n("Carrot Launcher"),
    n("Black Tee"),
    n("Spiked Menace"),
    n("Gold Fishing Rod"),
    n("Golden Net"),
    n("Pharaoh Bow"),
    n("Plat Fishing Rod"),
    n("Platinum Shins"),
    n("Plat Hatchet"),
    n("Platinum Pickaxe"),
    n("Platinum Boots"),
  ),

  order(
    "Dudes Next Door",
    n("Spore Cap", 125),
    n("Frog Leg", 120),
    n("Bean Slices", 115),
    n("Slime Sludge", 110),
    n("Snake Skin", 105),
    n("Carrot Cube", 100),
    n("Glublin Ear", 100),
    n("Plank", 90),
    n("Bullfrog Horn", 90),
    n("Pocket Sand", 100),
    n("Corn Kernels", 100),
    n("Megalodon Tooth", 95),
    n("Stick", 80),
    n("Crabby Cakey", 150),
    n("Rats Tail", 100),
    n("Acorn", 70),
    n("Amarok Slab", 2),
    n("Coconotnotto", 100),
    n("Furled Flag", 100),
    n("Pincer Arm", 80),
    n("Potato Remains", 80),
    n("High Steaks", 80),
    n("Wakka Cherry", 80),
    n("Singlecle", 80),
    n("Shrapshell", 80),
    n("Ripped Tunic", 2),
  ),

  order(
    "Down Underlivery",
    n("Nuget Cake"),
    n("Glass Shard"),
    n("Ghost", 5),
    n("Woodular Circle"),
    n("Golden Plop"),
    n("Yellow Snowflake"),
    n("Ice Age 3"),
    n("Black Lense"),
  ),

  order(
    "Alpine Suppliers",
    n("Floof Ploof", 250),
    n("Melty Cube", 230),
    n("Moustache Comb", 220),
    n("Sticky Stick", 210),
    n("Mamooth Tusk", 200),
    n("Snow Ball", 180),
    n("Pen", 170),
    n("Cracked Glass", 160),
    n("Sippy Straw", 150),
    n("Cryosnake Skin", 145),
    n("Audio Cord", 140),
    n("Contact Lense", 135),
    n("Ram Wool", 100),
    n("Blood Bone", 50),
  ),

  order(
    "Cosmic Carrier",
    n("Purple Mush Cap", 500),
    n("Half Eaten Donut", 500),
    n("Lost Batteries"),
    n("Alien Hive Chunk", 300),
    n("Skelefish", 250),
    n("Bottle Cap", 1000),
    n("Worker Bee", 300),
    n("Tongue Bone", 300),
    n("Crumpled Wrapper", 300),
    n("Lustre Ore", 300),
    n("Empty Oyster Shell", 300),
    n("Cubed Logs", 300),
    n("Pearler Shell"),
    n("Condensed Zap", 300),
    n("Starfire Ore", 100),
    n("Fairy", 300),
  ),
];

const d = getDropperMaker("post office");
export const postOfficeDrops = [
  d(
    "Simple Shippin'",
    "YumYum Grotto",
    pd("Armor Upgrade Stone I", 13.6, 2),
    pd("Weapon Upgrade Stone I", 13.59),
    pd("Tool Upgrade Stone I", 13.64),
    pd("Golden Jam", 13.38),
    pd("Peanut", 50),
    pd("Power Statue", 13.58),
    pd("Small Experience Balloon", 5.42),
    pd("Feasty Statue", 5.39),
    pd("Forest Villa Key", 5.19),
    pd("Efaunt's Tomb Key", 1.12),
    pd("Helmet Upgrade Stone I", 1.13),
    pd("Gem", 0.1),
  ),

  d(
    "Plan-it Express",
    "YumYum Grotto",
    pd("Armor Upgrade Stone I", 11.6, 2),
    pd("Weapon Upgrade Stone I", 11.84, 2),
    pd("Golden Nomwich", 11.81),
    pd("Average Speed Potion", 11.88, 100),
    pd("Small Experience Balloon", 11.82),
    pd("Feasty Statue", 11.72),
    pd("Armor Upgrade Stone II", 5.12),
    pd("Tool Upgrade Stone II", 5.24),
    pd("Kachow Statue", 5.2),
    pd("Forest Villa Key", 5.06),
    pd("Helmet Upgrade Stone I", 5.18),
    pd("Small EXP Potion", 1.21, 100),
    pd("Efaunt's Tomb Key", 1.14),
    pd("Weapon Upgrade Stone II", 1.11),
    pd("Gem", 0.07),
  ),

  d(
    "Dudes Next Door",
    "YumYum Grotto",
    pd("Armor Upgrade Stone I", 11.29, 2),
    pd("Weapon Upgrade Stone I", 11.15, 2),
    pd("Golden Kebabs", 10.99),
    pd("Average EXP Potion", 11.21, 100),
    pd("Radioactive Waste", 11.28, 20),
    pd("Small Experience Balloon", 11.22),
    pd("Armor Upgrade Stone II", 11.17),
    pd("Tool Upgrade Stone II", 11.4),
    pd("Weapon Upgrade Stone II", 3.97),
    pd("Efaunt's Tomb Key", 4.12),
    pd("Armor Upgrade Stone II", 0.97, 2),
    pd("Tool Upgrade Stone II", 1, 2),
    pd("Weapon Upgrade Stone III", 0.14),
    pd("Gem", 0.11, 2),
  ),

  d(
    "Down Undelivery",
    "YumYum Grotto",
    pd("Armor Upgrade Stone II", 9.76, 2),
    pd("Weapon Upgrade Stone II", 9.93, 2),
    pd("Golden Ham", 9.68),
    pd("Decent Speed Potion", 9.96, 100),
    pd("Radioactive Waste", 9.61, 30),
    pd("Small Experience Balloon", 9.69),
    pd("Cauldron Statue", 9.65),
    pd("Beholder Statue", 9.75),
    pd("Armor Upgrade Stone II", 3.87),
    pd("Tool Upgrade Stone II", 3.92),
    pd("Bullseye Statue", 3.92),
    pd("Forest Villa Key", 3.99),
    pd("Helmet Upgrade Stone I", 3.94),
    pd("Average EXP Potion", 0.77, 100),
    pd("Efaunt's Tomb Key", 0.72),
    pd("Weapon Upgrade Stone III", 0.81),
    pd("Gem", 0.04),
  ),

  d(
    "Alpine Suppliers",
    "YumYum Grotto",
    pd("Armor Upgrade Stone I", 8.87, 2),
    pd("Weapon Upgrade Stone I", 8.91, 2),
    pd("Golden Bread", 8.7),
    pd("Decent Speed Potion", 8.83, 100),
    pd("Radioactive Waste", 8.72, 50),
    pd("Small Experience Balloon", 8.85),
    pd("EhExPee Statue", 8.67),
    pd("Radioactive Waste", 4.01, 100),
    pd("Nuget Cake", 4.07),
    pd("Woodular Circle", 3.94),
    pd("Golden Plop", 3.97),
    pd("Armor Upgrade Stone III", 3.97),
    pd("Tool Upgrade Stone III", 4.02),
    pd("Seesaw Statue", 3.92),
    pd("Efaunt's Tomb Key", 3.95),
    pd("Helmet Upgrade Stone I", 4.1),
    pd("Average EXP Potion", 0.81, 100),
    pd("Chizoar's Cavern Key", 0.78),
    pd("Weapon Upgrade Stone III", 0.79),
    pd("Warped Helmet Upgrade Stone", 0.08),
    pd("Gem", 0.07),
  ),

  d(
    "Cosmic Carrier",
    "YumYum Grotto",
    pd("Armor Upgrade Stone IV", 18.09, 3),
    pd("Weapon Upgrade Stone IV", 17.68, 2),
    pd("Tool Upgrade Stone IV", 17.81, 2),
    pd("Golden Ribs", 17.88),
    pd("Cooking Ladle", 17.77, 3),
    pd("Medium Experience Balloon", 6.84),
    pd("Colosseum Ticket", 0.18),
    pd("Armor Upgrade Stone C", 1.92),
    pd("Weapon Upgrade Stone C", 1.84),
  ),
];
